import { Badge } from "components/ui/badge";
import { CopyButton } from "components/ui/copy-button";
import { ApplicationSummary } from "../types";
import Card from "./Card";

const OpenBankingBadge = ({ linked }: { linked?: boolean | null }) => {
  if (linked === true) {
    return (
      <Badge variant="success" className="shrink-0 whitespace-nowrap">
        Open banking linked
      </Badge>
    );
  }
  if (linked === false) {
    return (
      <Badge variant="warning" className="shrink-0 whitespace-nowrap">
        Needs open banking
      </Badge>
    );
  }
  return null;
};

interface ApplicantsProps {
  application: ApplicationSummary;
  // Per applicant, in the order `application.applicants` lists them.
  openBankingLinked?: (boolean | null)[];
}

const Applicants: React.FC<ApplicantsProps> = ({
  application,
  openBankingLinked,
}) => {
  const applicants = application.applicants ?? [];

  if (!applicants.length) {
    return null;
  }

  return (
    <Card title="Applicants">
      <div className="p-6">
        <ul className="space-y-4">
          {applicants.map((applicant, index) => {
            const name = `${applicant.forename} ${applicant.surname}`;

            return (
              <li key={applicant.uuid} className="flex items-center gap-3">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-1">
                    <p className="min-w-0 break-words font-medium text-brand-copy-primary">
                      {name}
                    </p>
                    <CopyButton
                      value={name}
                      label={`Copy ${name}'s name`}
                      className="h-7 w-7 shrink-0"
                    />
                  </div>
                </div>
                <OpenBankingBadge linked={openBankingLinked?.[index]} />
              </li>
            );
          })}
        </ul>
      </div>
    </Card>
  );
};

export default Applicants;
